import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.number.is-integer.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.split.js";
import _createForOfIteratorHelper from "C:/project/\u6587\u5316\u5BAB/code/whg/Web/Web/node_modules/@vue/babel-preset-app/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { fetchCreate, fetchUpdate, fetchDetail, fetchFloor } from '@/api/PMS/baseInformation/house';
import { fetchListByType } from '@/api/PMS/dic/dic';
import { fetchTreeList } from '@/api/PMS/treeList/index.js';
export default {
  props: ['routerIdArr', 'keyValue', 'showDialog'],
  data: function data() {
    var checkOrder = function checkOrder(rule, value, callback) {
      setTimeout(function () {
        if (!Number.isInteger(Number(value))) {
          callback(new Error('请输入数字值'));
        } else {
          callback();
        }
      }, 100);
    };

    return {
      ruleForm: {
        upIdList: '',
        houseOrder: '',
        floorNumber: '',
        houseCode: '',
        roomNum: '',
        houseType: '',
        houseUseArea: '',
        houseStatus: ''
      },
      rules: {
        upIdList: [{
          required: true,
          message: '请选择上级机构',
          trigger: 'change'
        }],
        houseOrder: [{
          required: true,
          message: '请输入门牌号',
          trigger: 'blur'
        }, {
          validator: checkOrder,
          trigger: 'blur'
        }],
        floorNumber: [{
          required: true,
          message: '请选择楼层',
          trigger: 'change'
        }],
        houseCode: [{
          required: true,
          message: '请输入房间代码',
          trigger: 'blur'
        }],
        roomNum: [{
          required: true,
          message: '请输入房间数量',
          trigger: 'blur'
        }],
        houseType: [{
          required: true,
          message: '请选择房间类型',
          trigger: 'change'
        }],
        houseUseArea: [{
          required: true,
          message: '请输入使用面积',
          trigger: 'change'
        }],
        houseArea: [{
          required: true,
          message: '请输入建筑面积',
          trigger: 'change'
        }],
        houseStatus: [{
          required: true,
          message: '请选择房间状态',
          trigger: 'change'
        }]
      },
      propstree: {
        label: 'name',
        value: 'id',
        children: 'pmsTree'
      },
      buildingId: '',
      isDisabled: false,
      floorOption: [],
      typeOption: [],
      stateOption: [],
      checked: '',
      options: [],
      isChecked: false,
      areaId: '',
      childData: {
        upIdList: []
      },
      cascaderItem: []
    };
  },
  watch: {
    showDialog: function showDialog(n, o) {
      if (n) {
        this.options = [];
        this.$refs.dataForm.resetFields();
        this.init();
      }
    },
    buildingId: function buildingId(n) {
      if (n) {
        this.loadFloorOptions(n);
      }
    }
  },
  created: function created() {
    this.init();
  },
  methods: {
    init: function init() {
      var _this = this;

      console.log('routerIdArr-house', this.routerIdArr);
      this.isDisabled = false;
      this.isChecked = false;
      this.typeOption = [];
      this.stateOption = [];
      this.childData.upIdList = '';
      this.options = [];
      this.loadMenuTree();
      this.loadRoomType();
      this.loadRoomState();
      this.$nextTick(function () {
        _this.$refs['dataForm'].clearValidate();
      });

      if (this.keyValue > 0) {
        var queryData = {
          id: this.keyValue
        };
        fetchDetail(queryData).then(function (response) {
          _this.childData = response.data.data;
          _this.childData.upIdList = _this.childData.upIdList.join(',').split(',');

          _this.loadFloorOptions(_this.childData.buildingId);

          if (_this.childData.houseIsRentable === 0) {
            _this.isChecked = false;
          } else {
            _this.isChecked = true;
          }
        });
      } else {
        this.childData = {
          upIdList: [],
          houseIsRentable: 0
        };
        this.childData.upIdList = this.routerIdArr;
        this.childData.buildingId = this.routerIdArr[this.routerIdArr.length - 2];
        this.loadFloorOptions(this.childData.buildingId);
        setTimeout(function () {
          _this.getCascaderItem(_this.childData.upIdList, _this.options);
        }, 1000);
      }
    },
    handleInitialAcceptanceDate: function handleInitialAcceptanceDate(time) {
      if (time && this.childData.secondAcceptanceDate) {
        var initialAcceptanceDate = new Date(time).getTime();
        var secondAcceptanceDate = new Date(this.childData.secondAcceptanceDate).getTime();

        if (initialAcceptanceDate > secondAcceptanceDate) {
          this.$message({
            message: '初次验收日期日期不能晚于二次验收日期',
            type: 'warning'
          });
          this.$set(this.childData, 'initialAcceptanceDate', '');
        }
      }
    },
    handleSecondAcceptanceDate: function handleSecondAcceptanceDate(time) {
      if (time && this.childData.initialAcceptanceDate) {
        var secondAcceptanceDate = new Date(time).getTime();
        var initialAcceptanceDate = new Date(this.childData.initialAcceptanceDate).getTime();

        if (initialAcceptanceDate > secondAcceptanceDate) {
          this.$message({
            message: '二次验收日期不能早于初次验收日期',
            type: 'warning'
          });
          this.$set(this.childData, 'secondAcceptanceDate', '');
        }
      }
    },
    changeTypeValue: function changeTypeValue(val) {
      var obj = {};
      obj = this.locations.find(function (item) {
        return item.dicValue === val;
      });
      this.childData.houseType = obj.dicName;
    },
    changeStateValue: function changeStateValue(val) {
      var obj = {};
      obj = this.locations.find(function (item) {
        return item.dicValue === val;
      });
      this.childData.houseStatus = obj.dicName;
    },
    handleRent: function handleRent(val) {
      this.childData.houseIsRentable = val === true ? 1 : 0;
    },
    loadMenuTree: function loadMenuTree() {
      var _this2 = this;

      var treeQuery = {
        flag: 21
      };
      fetchTreeList(treeQuery).then(function (response) {
        _this2.options = response.data.data;
      });
    },
    loadRoomType: function loadRoomType() {
      var _this3 = this;

      fetchListByType('house_type').then(function (r) {
        _this3.typeOption = r.data.data;
      });
    },
    loadRoomState: function loadRoomState() {
      var _this4 = this;

      fetchListByType('house_status').then(function (r) {
        _this4.stateOption = r.data.data;
      });
    },
    loadFloorOptions: function loadFloorOptions(val) {
      var _this5 = this;

      var queryList = {
        buildingId: val
      };
      fetchFloor(queryList).then(function (r) {
        _this5.floorOption = r.data.data;
      });
    },
    getBuildingId: function getBuildingId(val) {
      this.cascaderItem = [];
      this.getCascaderItem(this.childData.upIdList, this.options);

      if (this.cascaderItem[this.cascaderItem.length - 1].flag !== '21') {
        this.$message({
          message: '请选择楼栋单元',
          type: 'error',
          duration: 3000
        });
        return false;
      }

      if (val) {
        this.buildingId = val[val.length - 2];
        this.loadFloorOptions(this.buildingId);
        this.isDisabled = false;
      }
    },
    // 选择楼层前先选择楼栋单元
    checkArea: function checkArea() {
      if (this.keyValue < 1) {
        if (this.cascaderItem[this.cascaderItem.length - 1].flag !== '21') {
          this.$message({
            message: '请先选择楼栋单元',
            type: 'error',
            duration: 3000
          });
          return false;
        }
      }
    },
    // 获取级联选择器的下拉选项的数据
    getCascaderItem: function getCascaderItem(val, opt) {
      var _this6 = this;

      return val.map(function (value, index, arr) {
        var _iterator = _createForOfIteratorHelper(opt),
            _step;

        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var item = _step.value;

            if (item.id === value) {
              opt = item.pmsTree;

              _this6.cascaderItem.push(item);
            }
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      });
    },
    handCreate: function handCreate() {
      var _this7 = this;

      this.$refs['dataForm'].validate(function (valid) {
        if (valid) {
          if (_this7.childData.houseOrder == null || _this7.childData.houseOrder == '') {
            _this7.childData.houseOrder = 0;
          }

          _this7.childData.unintId = _this7.childData.upIdList[_this7.childData.upIdList.length - 1];

          if (_this7.keyValue > 0) {
            delete _this7.childData.areaGroupId;
            delete _this7.childData.areaGroupName;
            delete _this7.childData.areaName;
            delete _this7.childData.buildingName;
            delete _this7.childData.unintName;
            delete _this7.childData.areaId;
            delete _this7.childData.upIdList;
            delete _this7.childData.upAreaId;
            delete _this7.childData.houseIsRentableName;
            delete _this7.childData.houseStatusName;
            delete _this7.childData.houseTypeName;
            delete _this7.childData.floorName;
            delete _this7.childData.opDate;
            fetchUpdate(_this7.childData).then(function () {
              _this7.$emit('handCancle', true);

              _this7.Alert({
                alertType: 'update'
              });
            });
          } else {
            if (_this7.cascaderItem[_this7.cascaderItem.length - 1].flag !== '21') {
              _this7.$message({
                message: '上级机构请选择楼栋单元',
                type: 'error',
                duration: 3000
              });

              return false;
            }

            fetchCreate(_this7.childData).then(function () {
              _this7.$emit('handCancle', true);

              _this7.Alert({
                alertType: 'add'
              });
            });
          }
        } else {
          _this7.Alert({
            alertType: 'valid'
          });
        }
      });
    },
    handCancle: function handCancle() {
      this.$emit('handCancle', 'offHouseEdit');
    }
  }
};